module.exports = __webpack_public_path__ + "static/media/garage.b0b29838.webp";